
import Userbody from "../components/Userbody";
import Authnavbar from "../components/Navbars";


function Authouser() {

    return(
        <div>
           <Authnavbar/>
            <Userbody/> 
        </div>

    )
    
}

export default Authouser;